import React from 'react';
import AuditTableValue from './AuditTableValue';
import { useQuery } from '../../graphql/hooks';
import { get } from 'lodash';
import { Button, IconButton } from '@mui/material';
import {
  ChevronLeft,
  ChevronRight,
  Circle,
  CircleOutlined,
} from '@mui/icons-material';
import { capitalize } from '../../teal-react/utils/format';
import { schema } from '../../graphql/schema';
import Utils from '../../teal-react/utils';
import SimpleCard from '../../teal-react/components/organisms/SimpleCard';

const AuditTableViewer = ({ table, id, current, labels }) => {
  const [index, setIndex] = React.useState(0);
  const auditTable = 'audit' + capitalize(table);
  const fields = get(schema, table);
  const { data } = useQuery(
    `query AuditViewer($where: String, $whereTable: String){
        ${auditTable}(where: $where){
          ${fields}
        }
        ${table}(where: $whereTable){
          ${fields}
        }
      }`,
    {
      networkOnly: true,
      variables: {
        where: JSON.stringify({
          [`${auditTable}Id`]: id,
        }),
        whereTable: JSON.stringify({ id }),
      },
    }
  );

  if (!data) {
    return null;
  }
  const results = [...data[table]];
  results.push(...data[auditTable]);
  // const data_object = index === null ? current : results[auditTable][index]
  return (
    <>
      <SimpleCard>
        <IconButton
          title="Newer"
          onClick={() => {
            if (index > 0) {
              setIndex(index - 1);
            } else if (index === 0) {
              setIndex(results.length);
            }
          }}
        >
          <ChevronLeft />
        </IconButton>
        <IconButton title="Current Values" onClick={() => setIndex(null)}>
          {index === 0 ? <Circle /> : <CircleOutlined />}
        </IconButton>
        {results &&
          results.map((r, i) => {
            return (
              <IconButton
                title={Utils.date.formatDate(r['updated_at'])}
                key={i}
                onClick={() => setIndex(i)}
              >
                {index === i + 1 ? <Circle /> : <CircleOutlined />}
              </IconButton>
            );
          })}
        <IconButton
          title="Older"
          onClick={() => {
            if (index !== 0 && index < results.length - 1) {
              setIndex(index + 1);
            } else if (index === 0 && results.length > 0) {
              setIndex(0);
            }
          }}
        >
          <ChevronRight />
        </IconButton>
      </SimpleCard>
      <SimpleCard>
        <table size="sm">
          <thead>
            <tr>
              <th style={{ width: '20%' }}>Field</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            {fields.split(' ').map((f, i) => {
              return (
                <tr key={i}>
                  <th>{f}</th>
                  <td>
                    <AuditTableValue data={results[index]} field={f} />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </SimpleCard>
    </>
  );
};

export default AuditTableViewer;
